export default "__VITE_ASSET__BycdoxQt__"